export const PRODUCT_TAB_CALCULATOR = "PRODUCT_TAB_CALCULATOR";
export const PRODUCT_TAB_SCHOOLBOOK = "PRODUCT_TAB_SCHOOLBOOK";
export const PRODUCT_TAB_STATIONERY = "PRODUCT_TAB_STATIONERY";
export const RECOMMENDED_FOR_MATH_CLASS = "RECOMMENDED_FOR_MATH_CLASS";
export const PRODUCT_TAB_UP_SELL = "PRODUCT_TAB_UP_SELL";
